// extracted by mini-css-extract-plugin
export var body = "_ma-0";
export var sectionHeader = "_ma-4";
export var shortcutColumns = "_ma-2";
export var shortcutList = "_ma-1";
export var shortcutSection = "_ma-3";